import { createAxiosInstance } from "../../axios/createAxiosInstance";
import { ROLES } from "../../utils/userRole";

// Create employee axios instance with refresh token handling and telemetry
const axiosEmployeeInstance = createAxiosInstance({
  baseURL: process.env.REACT_APP_API_URL + "/emp",
  tokenKey: "employeeToken",
  userType: "employee",
  endpointPrefix: "/emp",
  role: ROLES.EMPLOYEE,
});

export default axiosEmployeeInstance;
